module.exports = __webpack_public_path__ + "static/img/call_hold_active.6fc353b6.svg";